import React, { Component } from 'react';
import CuentaMenu from './CuentaMenu.jsx';

class EmpresaMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opcionSeleccionadaId: 0,
		    isFeching: false 
        }
        this.getEmpresaData = this.getEmpresaData.bind(this);
        this.seleccionarOpcionRama = this.seleccionarOpcionRama.bind(this);
    }

	    getEmpresaData(id) {
            this.setState({
            opcionSeleccionadaId: 0,
            isFeching: true,
        }, this.props.getEmpresaData(id));
    }
    /**
     * 
     * @param {any} idOpcion
     * @param {any} id
     * @param {any} callback
     */
    seleccionarOpcionRama(idOpcion, id, callback) {
        this.setState({
            opcionSeleccionadaId: idOpcion
        }, callback(id));
    }

	componentWillReceiveProps(nextProps) {
        /*No importa cual fuese el resultado siempre seteo el valor del spinner en false*/
        this.state.isFeching = false;
    }

    render() {
        const { seleccionarOpcionRama } = this;
        const { opcionSeleccionadaId } = this.state;
        const { getTarjetaData, getCuentaData, getSaldosResumenesData, getIngresoAjustesData, data } = this.props;
        const { cuentaDatos, entidadTipo } = data;

        let selected = (cuentaDatos == undefined);
        let empresaDescripcion = this.props.data.empresa.Descripcion + " (" + this.props.data.empresa.TipoDeEmpresa + ")";
        
        let cuentas = this.props.data.empresa.accounts.map((cuenta, index) => {
            return (
                <CuentaMenu
                    entidadTipo={entidadTipo}
                    cuenta={cuenta}
                    cuentaDatos={cuentaDatos}
                    opcionSeleccionadaId={opcionSeleccionadaId}
                    primeraCuenta={(index == 0)}
                    getCuentaData={getCuentaData}
                    getSaldosResumenesData={getSaldosResumenesData}
                    getIngresoAjustesData={getIngresoAjustesData}
                    getTarjetaData={getTarjetaData}
                    seleccionarOpcionRama={seleccionarOpcionRama} />
            );
        });

        return (
            <div className="row">
                {this.state.isFeching == true &&
                    < div className="loading"> Loading &#8230;</div>}

                <div className="col-xs-12">
                    <div className="row bottom-separator-xxs">
                        <div className="col-xs-12">
                            {selected ?
                                <a className="btn-link btn-link-labeled-primary">{empresaDescripcion}&nbsp;<i className="fa fa-caret-right" aria-hidden="true"></i></a>
                                :
                                <a className="btn-link btn-link-labeled" onClick={() => this.getEmpresaData(this.props.data.empresa.Id)}>{empresaDescripcion}</a>
                            }
                        </div>
                    </div>
                    {cuentas}
                </div>
            </div>
        );
    }
}

export default EmpresaMenu;